import { post } from './request'
import { IWardrobeWithProduct } from "../common/WardrobeTypes";
import { getCity } from '@/utils/access-tool'
import { IFrameInfo } from '@/types/sourceData'
import { FrameMigrationConfig, normalizeFrameId } from '@/utils/normalizeFrameIds'

export const getAutoFillFuncArea = async <T>(likeComponents: any, query: any) => {
  return await post<T>('/v2/autofillFuncAreas', { likeComponents, query }, { loadingText: '正在生成可替换的内配' })
}

export const getWardrobeExtraInfo = async <T>(wardrobeWithProduct: IWardrobeWithProduct, isSilence = true) => {
  return await post<T>('/v1/getWardrobeExtraInfo', { wardrobeWithProduct }, { isSilence })
}

export const getRecommendFrames = async (params: any, migrationConfig: FrameMigrationConfig): Promise<IFrameInfo[]> => {
  const cityInfo = await getCity() || {};
  params.zipcode = cityInfo.zipcode;
  console.log('rf:params', params);
  const recommendations = await post<IFrameInfo[]>('/v1/recommendFrames', { ...params }, { loadingText: '正在生成可替换的内配' })
  return (recommendations || []).map((item) => {
    const frame = normalizeFrameId(item.frame, migrationConfig)
    return frame === item.frame ? item : { ...item, frame }
  })
}
